import React from "react";
import UserService from "../services/UserService";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { Navigate } from "react-router-dom";

class ForgotPassword extends React.Component {
  app = this.props.app;

  state = {
    email: "",
    redirectToHome: false,
  };

  forgotPassword = async () => {
    console.log("forgotPassword", this.state.email);

    try {
      const message = await UserService.reset(this.state.email);
      console.log("reset response :", message);
      this.setState({ redirectToHome: true });
    } catch (err) {
      this.app.handleSnackbarOpen(err, this.app.snackbarClassNames.ERROR);
    }
  };

  render() {
    var buttonStyle = {
      margin: "20px",
    };

    if (this.state.redirectToHome === true) {
      return (
        <Navigate
          to={{
            pathname: "/",
          }}
        />
      );
    }

    return (
      <div>
        <div className="HomeHeader">
          <span className="HomeHeader-logo" />
          <h2>Tracy</h2>
        </div>
        <div className="HomeBody">
          <div className="ColumnCenter">
            <h1>Reset your password</h1>

            <p>Enter your email address below.</p>

            <TextField
              type="email"
              label="Email"
              variant="outlined"
              onChange={(event) => this.setState({ email: event.target.value })}
            />
            <Button style={buttonStyle} color="primary" variant="contained" onClick={this.forgotPassword}>
              Send request
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

export default ForgotPassword;
